module.exports = __webpack_public_path__ + "media/white-label/organization-info-8786d077.png";